export const PLAYER_CREDENTIALS = 'j8Hkl0UYqwW4r';
export const PLAYER_USERNAME = 'johndoe';
export const CONTEXT_SELECT_MAIN_VIDEO = 'selectMainVideo';